/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Contract_Status_Enum =
  | 'SIGNED'
  | 'UNSIGNED';

export type SubCatalogByIdQueryVariables = Exact<{
  id: string;
}>;


export type SubCatalogByIdQuery = { sub_catalog_by_pk: { id: string, name: string, supplier_company_id: string, sub_catalog_packagings: Array<{ id: string, packaging_sku: number }>, contracts: Array<{ id: string, status: Types.Contract_Status_Enum }> } | null };


export const SubCatalogByIdDocument = /*#__PURE__*/ gql`
    query SubCatalogById($id: uuid!) {
  sub_catalog_by_pk(id: $id) {
    id
    name
    supplier_company_id
    sub_catalog_packagings {
      id
      packaging_sku
    }
    contracts(order_by: {buying_company: {tradeName: asc}}) {
      id
      status
    }
  }
}
    `;

/**
 * __useSubCatalogByIdQuery__
 *
 * To run a query within a React component, call `useSubCatalogByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubCatalogByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubCatalogByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubCatalogByIdQuery(baseOptions: Apollo.QueryHookOptions<SubCatalogByIdQuery, SubCatalogByIdQueryVariables> & ({ variables: SubCatalogByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubCatalogByIdQuery, SubCatalogByIdQueryVariables>(SubCatalogByIdDocument, options);
      }
export function useSubCatalogByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubCatalogByIdQuery, SubCatalogByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubCatalogByIdQuery, SubCatalogByIdQueryVariables>(SubCatalogByIdDocument, options);
        }
// @ts-ignore
export function useSubCatalogByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubCatalogByIdQuery, SubCatalogByIdQueryVariables>): Apollo.UseSuspenseQueryResult<SubCatalogByIdQuery, SubCatalogByIdQueryVariables>;
export function useSubCatalogByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubCatalogByIdQuery, SubCatalogByIdQueryVariables>): Apollo.UseSuspenseQueryResult<SubCatalogByIdQuery | undefined, SubCatalogByIdQueryVariables>;
export function useSubCatalogByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubCatalogByIdQuery, SubCatalogByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubCatalogByIdQuery, SubCatalogByIdQueryVariables>(SubCatalogByIdDocument, options);
        }
export type SubCatalogByIdQueryHookResult = ReturnType<typeof useSubCatalogByIdQuery>;
export type SubCatalogByIdLazyQueryHookResult = ReturnType<typeof useSubCatalogByIdLazyQuery>;
export type SubCatalogByIdSuspenseQueryHookResult = ReturnType<typeof useSubCatalogByIdSuspenseQuery>;
export type SubCatalogByIdQueryResult = Apollo.QueryResult<SubCatalogByIdQuery, SubCatalogByIdQueryVariables>;